<div class="container">
  <div class="row card">
    <div class="card-body col-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openScrollableContent(transcript)">
        View video transcript
      </button>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - Brainstorming</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6" style="height: 35vh">
    <p>
      In the last 15 years, I've been working with a lot of people in helping
      them to write their life story. One of the most difficult things is to
      have that blank piece of paper and not know where to begin, but I'm going
      to give you some really good tips and tricks to help you get started. Just
      like an athlete warms up, a writer needs to spend some time and energy in
      the beginning of the process. You don't want to spend half your time
      staring at a blank screen or a blank page.
    </p>
    <p>
      There are two techniques that work the best. One is freewriting or
      brainstorming, kind of like writing a grocery list, and then the other one
      is visual or photographs or looking at mementos. These will provide
      inspiration for you to choose your first topics.
    </p>
    <p>
      One of the first things we're going to start with is the freewriting or
      brainstorming, and I've had a few of my students call it the brain dump.
      So, you take that blank page and a pen, and you sit down for 10 minutes.
      Turn off your phone. Don't let anything interrupt you. You're going to
      just write whatever memories come to mind, and don't worry if you repeat
      something on that page. You'll find sometimes that happens, and those are
      the topics that might be the most impactful events in your life where you
      want to start with your first story.
    </p>
    <p>
      This next technique is so fun. This is the visual. This is where you get
      to go through your closets and your drawers. Pull out those old scrapbooks
      and photograph albums. Look around the house for some sort of family
      memento that you might have been keeping for all these years. This is
      going to provide inspiration for one of your greatest stories.
    </p>
    <p>
      Now that you finished the warm up, let's get started with the writing
      process. What we want to do next is choose from the list that you've
      prepared 5 to 15 ideas. These are going to turn into stories. So, on the
      TSOLife Brainstorming Worksheet, let's start writing them down. More
      in-depth videos are available in the resource tab below if you want to see
      these ideas in action. If you feel like you still need some inspiration,
      we've compiled an idea bank of ideas for stories. Just click on the list
      to the right, and it will populate on your brainstorming list.
    </p>
    <p>
      Great job! You've accomplished the hardest part. Now, we can get started
      in really writing the stories. I can't wait to tell you about the next
      step!
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
